export default __webpack_public_path__ + "static/media/splashScreen.1ea6df45.png";